import { render, staticRenderFns } from "./magage1.vue?vue&type=template&id=ef9193c6&scoped=true"
import script from "./magage1.vue?vue&type=script&lang=js"
export * from "./magage1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef9193c6",
  null
  
)

export default component.exports